import { useMemo } from "react";
import { ChannelFeaturesEnum } from "types/working-model";

export const useDrmExpected = (features: string[] | undefined | null): boolean => {
	return useMemo(() => {
		return !!features?.includes(ChannelFeaturesEnum.mux_drm);
	}, [features]);
};